import BaseService from "@/shared/base.service";

import { User } from "@/types/model/user";

import { useAlertStore } from "@/stores/alert.store";

import type { UserResponse } from "@/types/response/user";
import type { UserDataResponse } from "@/types/response/userData";

export class UserService {
  static async GetAllUsers(
    page: number,
    size: number,
  ): Promise<UserResponse | null> {
    try {
      const params = {
        page,
        size,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<UserResponse>(
        `users`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetAllUsers:", error);
      return null;
    }
  }

  static async GetUserData(): Promise<UserDataResponse | null> {
    try {
      const response = await BaseService.get<UserDataResponse>(`profile`);

      return response ?? null;
    } catch (error) {
      console.error("Error in GetUserData:", error);
      return null;
    }
  }

  static async GetUserById(user_id: string): Promise<UserDataResponse | null> {
    try {
      const params = {
        user_id,
      };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<UserDataResponse>(
        `users`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetUserById:", error);
      return null;
    }
  }

  static async MfaActivate(): Promise<any | null> {
    try {
      const response = await BaseService.get<any>(
        `mfa/setup`,
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in MfaActivate:", error);
      return null;
    }
  }

  static async ResetMfa(user_id: string): Promise<any | null> {
    try {
      const response = await BaseService.post<any>(
        `mfa/reset?user_id=${user_id}`
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in MfaActivate:", error);
      return null;
    }
  }

  static async CreateUser(payload: object): Promise<User | null> {
    try {
      const response = await BaseService.post<User>(`users`, payload);

      if (response) {
        useAlertStore().show("success", "Usuário criado com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in CreateUser:", error);
      return null;
    }
  }

  static async UpdateUser(payload: object): Promise<User | null> {
    try {
      const response = await BaseService.put<User>(`users`, payload);

      if (response) {
        useAlertStore().show("success", "Usuário atualizado com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in UpdateUser:", error);
      return null;
    }
  }

  static async DeleteUser(payload: object): Promise<User | null> {
    try {
      const response = await BaseService.delete<User>(`users`, payload);

      if (response) {
        useAlertStore().show("warning", "Usuário removido com sucesso.");
      }

      return response ?? null;
    } catch (error) {
      console.error("Error in DeleteUser:", error);
      return null;
    }
  }
}
